import { Chart as IChart, Pie, PieConfig } from '@ant-design/charts';
import { jobSubTableAccountsData, jobTypesPaper } from '../../subTableConfig';
import { DeliveryInfoRowType } from '../deliveryInfoData';
import { useJobDetailsProvider } from '../../../../../../../context/jobDetails';

interface PieChartData {
  type: DeliveryInfoRowType; // DataType;
  value: number;
  label: string;
}

const filteredChartData = jobSubTableAccountsData.filter(item => jobTypesPaper.includes(item.jobType));

const pieChartData: PieChartData[] = [
  {
    type: 'PENDING',
    value: 2,
    label: 'Pending',
  },
  {
    type: 'IN TRANSIT',
    value: 2,
    label: 'In Transit',
  },
  {
    type: '<3 DAYS',
    value: 1,
    label: '<3 Days',
  },
  {
    type: '3-5 DAYS',
    value: 3,
    label: '3-5 Days',
  },
  {
    type: '>5 DAYS',
    value: 1,
    label: '>5 Days',
  },
  {
    type: 'EXCEPTION MAIL',
    value: 1,
    label: 'Exception Mail',
  },
];

const config: PieConfig = {
  appendPadding: 10,
  height: 340,
  data: pieChartData,
  angleField: 'value',
  colorField: 'type',
  radius: 1,
  innerRadius: 0.7,
  label: {
    text: 'value', // (item: PieChartData) => item.value || '',
    style: {
      fontWeight: 'bold',
      fontSize: 14,
    },
    transform: [
      {
        type: 'overlapHide',
      },
    ],
  },
  legend: {
    maxRow: 10,
    color: {
      title: false,
      position: 'right',
      rowPadding: 5,
      layout: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
  },
  annotations: [
    {
      tooltip: false, // Without this param on hover center text appears tooltip.
      type: 'text',
      style: {
        text: `${filteredChartData?.length || 8}\nTotal Volume`,
        x: '50%',
        y: '50%',
        textAlign: 'center',
        fontSize: 26,
        fontStyle: 'bold',
      },
    },
  ],
  interaction: { tooltip: true },
  tooltip: (item: PieChartData) => ({
    name: item.label,
    value: item.value,
  }),
  animate: false,
};

function Chart() {
  const { handleSelectedTable } = useJobDetailsProvider();

  const handleChartReady = (chartInstance: IChart) => {
    chartInstance.on('click', (event: { data?: { data?: PieChartData } }) => {
      const data = event?.data?.data;

      if (data) {
        handleSelectedTable({ row: data?.type, column: 'percentage' });
      }
    });
  };

  return <Pie {...config} onReady={handleChartReady} />;
}

export default Chart;
